import { ActionIcon, Loader, LoadingOverlay } from "@mantine/core";
import { ArrowLeftIcon } from "@phosphor-icons/react";
import { createFileRoute, Link } from "@tanstack/react-router";
import { useState } from "react";
import { toast } from "react-toastify";

import api from "@/services/api";

export const Route = createFileRoute("/app/como-chegar/")({
  component: DriverCompanyMap,
  loader: async ({ context }) => {
    const { auth } = context.store.getState();

    const driverCompanyId = auth.driver?.company.id;
    const defaultData = { data: { googleMaps: null } };

    if (!driverCompanyId) return defaultData;

    try {
      const { data } = await api.get<{ googleMaps: string }>(`/settings/company/${driverCompanyId}`);

      return { data };
    } catch (error) {
      console.error("Error fetching Google Maps URL:", error);
      toast.error("Erro ao carregar o mapa. Tente novamente mais tarde.");
      return defaultData;
    }
  },
  pendingComponent: () => <LoadingOverlay visible overlayProps={{ blur: 3 }} loaderProps={{ children: <Loader type="ring" size="xl" scale="2" /> }} />,
  head: () => ({
    meta: [{ title: "Como Chegar" }]
  })
});

export function DriverCompanyMap() {
  const { data } = Route.useLoaderData();

  const [iframeLoaded, setIframeLoaded] = useState(false);

  return (
    <div className="maps relative">
      {/* <div className="absolute bottom-12 left-1/2 size-42 -translate-x-1/2 rounded-md bg-white p-2 text-center shadow">
        <p className="leading-none">Bloco para conteúdo adicional aqui</p>
      </div> */}

      <ActionIcon component={Link} to={"/"} className="absolute! bottom-12 left-1/2 z-10 -translate-x-1/2 shadow" size="xl" color="primary">
        <ArrowLeftIcon weight="bold" />
      </ActionIcon>

      {data.googleMaps && (
        <iframe className="relative h-[inherit] w-dvw" src={data.googleMaps} loading="lazy" onLoad={() => setIframeLoaded(true)}>
          <LoadingOverlay visible={!iframeLoaded} loaderProps={{ type: "oval" }} className="absolute!" />
        </iframe>
      )}
    </div>
  );
}
